import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DropDownModel } from '../../../domain/model/common/dropDownModel';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonServices } from '../../../domain/service/commonService';
import { GooglePlacesService } from '../../../domain/service/GooglePlaceService';
import { ProfileService } from '../../../domain/service/profileService';
import { OwnerAccount } from '../../../domain/model/profile/indiviualPropertyOwnerProfie';
import { atLeastOneRequiredValidator } from '../../../shared/utils/atLeastOneRequiredValidator';
import { HotelMotelData } from '../../../domain/model/profile/individualBedAccount';
import { Dialog } from '@angular/cdk/dialog';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-b-bhotel-motel',
  templateUrl: './b-bhotel-motel.component.html',
  styleUrl: './b-bhotel-motel.component.css'
})
export class BBHotelMotelComponent implements OnChanges , OnInit{
  addressType: string = '1';
  states: DropDownModel[] = [];
  country: DropDownModel[] = [];
  ownerForm  !: FormGroup; 
  suggestions: any[] = [];
  @Input() data!: HotelMotelData;  
  dialog = inject(Dialog);
  hasChanges = false;
  constructor(private fb: FormBuilder, private commonServices: CommonServices,private profileServices: ProfileService, private googlePlacesService: GooglePlacesService) {

  }
  ngOnInit(): void {
    this.entityRentalPropertyLicense.valueChanges.subscribe((value) => {
       this.hasChanges = true;
    });
    this.commonServices.getAllCountry()
    .subscribe(data => {
      this.country = data.sort((a, b) => a.name.localeCompare(b.name));;
    });


  this.commonServices.getAllState(233)
    .subscribe(data => {
      this.states = data.sort((a, b) => a.name.localeCompare(b.name));
    });
  }
  entityRentalPropertyLicense = new FormGroup(
    {
      departmentOfBusiness: new FormControl("", [Validators.pattern(/^[a-zA-Z1-9][a-zA-Z0-9]*$/)]),
      taxCertificateNumber: new FormControl(""),
      stateCertificateHasBeenApplied: new FormControl(null, [Validators.requiredTrue]),
      reasonWhy: new FormControl("", [Validators.required]),
      certificateOfRegistration: new FormControl(""),
      localBusinessTaxReceipt: new FormControl(""),
      cityOfRegistration: new FormControl(""),
      primaryContactFirstName: new FormControl("", [Validators.required, Validators.maxLength(200)]),
      primaryContactLastName: new FormControl("", [Validators.required, Validators.maxLength(200)]),
      primaryContactEmail: new FormControl("", [Validators.required, Validators.maxLength(320), Validators.email]),
      primaryContactPhoneNumber: new FormControl("", [
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/),
      ]),
    },
    { validators: atLeastOneRequiredValidator(["reasonWhy", "stateCertificateHasBeenApplied", "taxCertificateNumber"]) }
  );
  ngOnChanges(changes: SimpleChanges): void {
    this.buildForm(this.data);
    this.ownerForm.get("printedName")?.disable();
    // Only the license form flagged changes, so editing anything else never enabled Save.
    this.ownerForm.valueChanges.subscribe(() => this.hasChanges = this.ownerForm.dirty || this.hasChanges);
  }
  radioChangeAddress(event: any) {
    this.addressType = event.value;
    if (event.value == "1") {
      this.ownerForm.get('addressName')?.clearValidators();
      this.ownerForm.get('addressName')?.updateValueAndValidity();

      this.ownerForm.get('addressOrPoBox')?.clearValidators();
      this.ownerForm.get('addressOrPoBox')?.updateValueAndValidity();

      this.ownerForm.get('cityStateProvince')?.clearValidators();
      this.ownerForm.get('cityStateProvince')?.updateValueAndValidity();

      this.ownerForm.get('country')?.clearValidators();
      this.ownerForm.get('country')?.updateValueAndValidity();

      this.ownerForm.get('ownerStreetAddress')?.addValidators(Validators.required);
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();



      this.ownerForm.get('city')?.addValidators(Validators.required);
      this.ownerForm.get('city')?.updateValueAndValidity();

      this.ownerForm.get('state')?.addValidators(Validators.required);
      this.ownerForm.get('state')?.updateValueAndValidity();

      this.ownerForm.get('zipCode')?.addValidators(Validators.required);
      this.ownerForm.get('zipCode')?.addValidators(Validators.maxLength(12));
      this.ownerForm.get('zipCode')?.addValidators(Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/));
      this.ownerForm.get('zipCode')?.updateValueAndValidity();

    }
    if (event.value == "2") {

      this.ownerForm.get('addressName')?.addValidators(Validators.required);
      this.ownerForm.get('addressName')?.updateValueAndValidity();

      this.ownerForm.get('addressOrPoBox')?.addValidators(Validators.required);
      this.ownerForm.get('addressOrPoBox')?.updateValueAndValidity();

      this.ownerForm.get('cityStateProvince')?.addValidators(Validators.required);
      this.ownerForm.get('cityStateProvince')?.updateValueAndValidity();

      this.ownerForm.get('country')?.addValidators(Validators.required);
      this.ownerForm.get('country')?.updateValueAndValidity();


      this.ownerForm.get('ownerStreetAddress')?.clearValidators();
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();

      this.ownerForm.get('aptUnitSuite')?.clearValidators();
      this.ownerForm.get('aptUnitSuite')?.updateValueAndValidity();

      this.ownerForm.get('city')?.clearValidators();
      this.ownerForm.get('city')?.updateValueAndValidity();

      this.ownerForm.get('state')?.clearValidators();
      this.ownerForm.get('state')?.updateValueAndValidity();

      this.ownerForm.get('zipCode')?.clearValidators();
      this.ownerForm.get('zipCode')?.updateValueAndValidity();
    }


  }

  async selectPlace(place: any) {


    this.suggestions = [];
    const details = await this.googlePlacesService.getPlaceDetails(place.place_id);
    let selectedZipCode = this.googlePlacesService.extractLocationDetails(details);
    if (selectedZipCode.zip) {
      this.ownerForm.get('zipCode')?.setValue(selectedZipCode.zip);
    }

    if (selectedZipCode.city) {
      this.ownerForm.get('city')?.setValue(selectedZipCode.city);
    }

    if (selectedZipCode.stateCode) {
      let stateId = this.states.find(e => e.iso2 == selectedZipCode.stateCode)?.id ?? 0;
      this.ownerForm.get('state')?.setValue(stateId);
    }

    if (selectedZipCode.address) {
      this.ownerForm.get('ownerStreetAddress')?.setValue(selectedZipCode.address);
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();
      this.ownerForm.get('ownerStreetAddress')?.markAsUntouched();
    }
  }

  private buildForm(data: HotelMotelData | undefined): void {
    
    this.ownerForm = this.fb.group({
      firstName: new FormControl(data?.owner.firstName, [
        Validators.required,
        Validators.maxLength(200),
      ]),
      lastName: new FormControl(data?.owner.lastName, [
        Validators.required,
        Validators.maxLength(200),
      ]),
      email: new FormControl(data?.owner.email, [
        Validators.required,
        Validators.maxLength(320),
        Validators.email
      ]),
      phoneNumber: new FormControl(data?.owner.phoneNumber, [
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
      ]),
      note: new FormControl(data?.individualBedAccount.note),
      ownerStreetAddress: new FormControl(data?.owner.streetAddress, Validators.required),
      aptUnitSuite: new FormControl(data?.owner.aptUnitSuite),
      city: new FormControl(data?.owner.city, Validators.required),
      state: new FormControl(data?.owner.stateId, [Validators.required, Validators.min(0)]),
      zipCode: new FormControl(data?.owner.zipCode, [
        Validators.required,
        Validators.maxLength(12),
        Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)
      ]),
      addressName: new FormControl(data?.owner.internationalAddressName),
      addressOrPoBox: new FormControl(data?.owner.internationalPoboxNumber),
      cityStateProvince: new FormControl(data?.owner.internationalCityStateProvince),
      country: new FormControl(data?.owner.countryId),
      printedName: new FormControl({value: data?.individualBedAccount.printedName, disabled: true} ),
      primaryContactFirstName: new FormControl(data?.individualBedAccount.primaryContactFirstName, Validators.required),
      primaryContactLastName: new FormControl(data?.individualBedAccount.primaryContactLastName, Validators.required),
      primaryContactEmail:new FormControl(data?.individualBedAccount.email, Validators.required),
      primaryContactPhone:new FormControl(data?.individualBedAccount.phone, Validators.required),
      notes: new FormControl(data?.individualBedAccount.note),
    })

    this.ownerForm.get("printedName")?.disable();
  }
  formHasChanges(value: boolean): void { 
    this.hasChanges = value;
  }
  /** Was an empty stub — the page never saved (QA 2026-10-04). Scoped to the logged-in account server-side. */
  save(): void {
    if (this.ownerForm.invalid) {
      this.ownerForm.markAllAsTouched();
      return;
    }
    const f = this.ownerForm.getRawValue();
    const l = this.entityRentalPropertyLicense?.getRawValue() ?? {};
    const model = {
      id: this.data?.individualBedAccount?.id,
      primaryContactFirstName: f.primaryContactFirstName, primaryContactLastName: f.primaryContactLastName,
      primaryContactEmail: f.primaryContactEmail, primaryContactPhone: f.primaryContactPhone,
      note: f.notes,
      owner: {
        id: this.data?.owner?.id, firstName: f.firstName, lastName: f.lastName, email: f.email,
        phoneNumber: f.phoneNumber, streetAddress: f.ownerStreetAddress, aptUnitSuite: f.aptUnitSuite,
        city: f.city, stateId: f.state, zipCode: f.zipCode, addressName: f.addressName,
        streetAddressOrPoBox: f.addressOrPoBox, cityStateProvince: f.cityStateProvince, countryId: f.country,
      },
      license: {
        regulationLicenseNumber: l.departmentOfBusiness, taxCertificateNumber: l.taxCertificateNumber,
        stateCertificateHasBeenApplied: l.stateCertificateHasBeenApplied, reasonWhy: l.reasonWhy,
      },
    };
    this.profileServices.updateHotelMotel(model).subscribe({
      next: () => { this.hasChanges = false; },
      error: (e) => console.error('Profile save failed', e),
    });
  }
      showChangePasswod(){
             const dialogRef = this.dialog.open(ChangePasswordComponent, {
                  width: "500px",
                  height: "510px",
                  disableClose: true,
                });
          }
}
